import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';

interface IValidateAccessResponse {
  access_token: string;
  resources: Record<string, string[]>;
}

const useAuthorizationService = () => {
  const request = useRequest<IValidateAccessResponse>();
  const path = 'authorization';
  const getUserResources = async (bearerToken: string): Promise<IValidateAccessResponse> => {
    return await request
      .getOne({ path: `${path}/validate-access`, headers: { authorization: bearerToken }, sendAuthorization: false })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  return { getUserResources };
};

export { useAuthorizationService };
